import { useEffect } from 'react';
import API from './api';

const DEFAULTS = {
  color_heading: '#ffffff',
  color_body: 'rgba(255,255,255,0.55)',
  color_muted: 'rgba(255,255,255,0.35)',
  color_accent: '#B49128',
  color_link: '#B49128',
};

export default function ThemeProvider() {
  useEffect(() => {
    API.get('/site-settings').then(r => {
      const colors = r.data?.theme_colors || {};
      const root = document.documentElement;
      root.style.setProperty('--theme-heading', colors.color_heading || DEFAULTS.color_heading);
      root.style.setProperty('--theme-body', colors.color_body || DEFAULTS.color_body);
      root.style.setProperty('--theme-muted', colors.color_muted || DEFAULTS.color_muted);
      root.style.setProperty('--theme-accent', colors.color_accent || DEFAULTS.color_accent);
      root.style.setProperty('--theme-link', colors.color_link || DEFAULTS.color_link);
      if (colors.color_accent) {
        root.style.setProperty('--gold', colors.color_accent);
      }
    }).catch(() => {});
  }, []);

  return null;
}
